$(function () {
    $('.js-testimonial-carousel').slick({
        autoplay:false,
        autoplaySpeed:5000,
        pauseOnHover: true,
        dots: true,
        arrows: true,
        fade: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        prevArrow: "<button type='button' class='slick-prev pull-left'><i class='fal ico-chevron-left' aria-hidden='true'></i></button>",
        nextArrow: "<button type='button' class='slick-next pull-right'><i class='fal ico-chevron-right' aria-hidden='true'></i></button>",
        responsive: [
            {
                breakpoint: 767,
                settings: {
                    mobileFirst: true,
                    arrows: false
                }
            }
        ],
    });
});